module.exports = __webpack_public_path__ + "static/LizardmanA-7d02914fad64b23ed4c5b19c2d7ac302.gif";